import React,{useState,useEffect} from 'react';
import {connect} from 'react-redux';
import { Button } from 'react-bootstrap';
import DataTableX from '../../components/datatable/DataTableX';
import {useTranslation} from 'react-i18next';
import * as RestService from '../../services/eisRest';
import * as moment from 'moment';




const  AttendanceOpenEventDatatable = (props) => {

    const [t] = useTranslation();        
    const [checkTime, setCheckTime] = useState(null);
    const [omitLockButton, setOmitLockButton] = useState(true);
    const tableName = t('attendance.label.openEvents'); 


    const clickHandler = (row) => {
        //row.target.id      
        //   props.parentCallback(row.target.id);  
           
           RestService.callAnyApi('attendance/setAttendanceCheck?id='+row.target.id, null)
           .then((data) => {
            setCheckTime(Date.now());
           })
           .catch((error) => {
             console.log(error);
           });

     };

    

    const removeZeroValues  = (value) => {

     
      if(value==='00:00' || value===0){value='';}

      return (
        <>
        {value}
        </>
      );
    }

    const columns = [       
        { name: "Id", data: "id", selector: "id", omit: true},
        { name: t('user.label.personalNumber'), data: "user.personalNumber", sortable: true, selector: "user.personalNumber"},    		      
        { name: t('user.label.firstName'), data: "user.address.firstName",  sortable: true,  selector: "user.address.firstName"} ,            
        { name: t('user.label.lastName'), data: "user.address.lastName",  sortable: true,  selector: "user.address.lastName"},       
        { name: t('attendance.label.event'), data: "eventType",  sortable: true,  selector: "eventType",cell:(row) => row.eventType ?   t('attendance.label.'+row.eventType) : ""},
        { name: t('attendance.label.time'), data: "date",  sortable: true,  selector: "date",cell:(row) => row.date ?  moment(row.date).format("DD.MM.YYYY HH:mm") : ""} 
       
     
    ];        


    const columnsData = [       
     //   { name: "Id", data: "id", searchable: false, orderable: false, search: {value: '',regex: false}},
        { name: t('user.label.personalNumber'), data: "user.personalNumber",  orderable: true, searchable: true, search: {value: '',regex: false}},    		     
        { name: t('user.label.firstName'), data: "user.address.firstName", orderable: true,  searchable: true, search: {value: '',regex: false}},
        { name: t('user.label.lastName'), data: "user.address.lastName", orderable: true,  searchable: true, search: {value: '',regex: false}},            
        { name: t('attendance.label.event'), data: "eventType", orderable: true,  searchable: true, search: {value: '',regex: false}},            
        { name: t('attendance.label.time'), data: "date", orderable: true,  searchable: true, search: {value: '',regex: false}},            
     
    ];    
            
     const url = RestService.getBaseURL()+"attendance/getOpenAttendanceTerminalEventList";   
     const urlExcel = "";          
    
   
 
   

      useEffect(() => {      
        setCheckTime(props.checkTime);
      }, [props.checkTime])


   
          
    
         return (
           
             <DataTableX
                 url={url}  
                 urlExcel={urlExcel}  
                 tableName={tableName}
                 columns={columns}   
                 columnsData={columnsData}                 
                 exportShow={false}
                 checkTime={checkTime}
             />
           
         );
    
 
  
 };

 const mapStateToProps = (state) => ({
    user: state.auth.currentUser
  });
  

export default connect(mapStateToProps, null)(AttendanceOpenEventDatatable);

